fx.ns("shared.screens", class SizeAlbum extends shared.screens.BaseChoiceScreen 
    {
        constructor()
        {
            super();
    
            this.showNext = false;
            this.showBack = fx.get("mode") == "creating";

            this.styleChoice = "circle";

            this.containerHeight = 450;

            this.title = fx.text("Choisissez la taille de votre album");
        }
        
        get currentShape()
        {
            return (fx.get("mode") == "creating") ? this.data.choosedShape : this.data.creation.shape_option;
        }

        get currentFormat()
        {
            return (fx.get("mode") == "creating") ? this.data.choosedFormat : this.data.creation.formatid;
        }

        set currentFormat(val)
        {
            if (fx.get("mode") == "creating")
                this.data.choosedFormat = val;
            else
                this.data.creation.formatid = val;
        }

        // asked by the order button, after the preview
        get preOrder()
        {
            return fx.get("mode") != "creating" && !!this.data.preOrderChoices;
        }

        // order flow, format already picked : an invitation to go larger - current format
        // pointed out, skip allowed, price differences
        get upgradeMode()
        {
            return this.preOrder && !this.data.formatChoicePending;
        }

        // a customer who never picked his format has to pick one now
        get canSkip()
        {
            return !this.data.formatChoicePending;
        }
    
        create() 
        {
            // after the preview the customer must always be able to step back, whatever the
            // choice state : the base class already does it, made explicit here on purpose
            if (this.preOrder)
                this._showBack = true;

            super.create();
    
            if (!this.data.creationFormats)
            {
                this.loading(true, fx.text("Chargement"));
                this.data.loadBookFormats();
            }
            else
                this.build();
        }
    
    
        onDataEvent(e)
        {
            if (e.type == "book-format-loaded")
                this.build();
        }
    
        build() 
        {
            if (this.upgradeMode)
                this.title = fx.text("Souhaitez-vous un format plus grand ?");

            super.build();

            // order flow : the formats the album can be printed in, cheapest first, with the
            // album price in each of them
            let formats, prices = null;

            if (this.preOrder)
            {
                formats = this.data.possibleFormats();

                prices = {};
                for (let i = 0; i < formats.length; i++)
                    prices[formats[i].id] = this.data.creation.formatPrice(formats[i].id);
            }
            else
                formats = this.data.availableFormats(this.data.choosedShape).sort(function (a, b) { return a.width - b.width; });

            // never picked : every format shows the album price. Already picked : only what
            // each format changes to it
            let reference = prices && this.upgradeMode ? prices[this.currentFormat] : undefined;
    
            for (let i = 0; i < formats.length; i++) 
            {
                let format = formats[i];
                let price = prices ? (reference === undefined ? this.orderPriceLabel(prices[format.id]) : this.orderPriceDifference(prices[format.id] - reference)) : fx.text("A partir de <strong>$€</strong>", format.price);
    
                let choice = new shared.components.ProductChoice("circle", format,  this.data.getFormatAsset(this.data.choosedShape, format.size), fx.text(format.title_new), fx.text(format.dimensions), price);

                // the current format is only pointed out when we invite to go larger
                if (this.upgradeMode && this.currentFormat == format.id)
                    choice.addClass("selected");

                if (prices && reference === undefined)
                    choice.addClass("album-price");
    
                this.addChoice(choice, fx.browser.isDesktop ? { width: 190, height:  320} : { width: 190, height:  320, left : "center" })
            }
    
            this.loading(false);
        }
    
        onChoiceClicked(format)
        {
            this.currentFormat = format.id;
            
            if (fx.get("mode") == "creating") 
                this.data.event("next-step");
            else
            {
                this.data.formatChoicePending = false;

                if (this.data.preOrderChoices) // screen asked by the order button, not by the info panel
                    this.data.event("creation-choice-done");
                else
                    this.trigger("reset-navigation");
            }
        }
    
    });
